import React, { useCallback } from 'react';
import "../../styles/collections/add_item_to_collection.css";
import { useEffect, useState } from "react";
import { firebaseAuth, firebaseFirestore } from "../firebase/firebase_configuration";
import { doc, getDoc, onSnapshot, updateDoc } from "firebase/firestore";
import { onAuthStateChanged } from "firebase/auth";
import { getItem } from "../repositories/movies_and_tvseries";
import AddCollection from "./add_collection";

import activeSaveImage from "../../images/home/save_icon/active_save.png";
import inactiveSaveImage from "../../images/home/save_icon/inactive_save.png";
import emptyCollectionImage from "../../images/collections/empty_collection.png";

const AddItemToCollection = ({getShow, setShow, getItemId}) => {
    const [getAShow, setAShow] = useState(false);
    const [getUserId, setUserId] = useState("");
    const [getCollections, setCollections] = useState([]);

    const onAdd = () => {
        setAShow(true);
    };

    const onDone = () => {
        setShow(false);
    };

    const onAddToCollection = async (id) => {
        try {
            const collectionRef = doc(firebaseFirestore, 'User Collections', getUserId); 
            const collectionDoc = await getDoc(collectionRef);
            if (collectionDoc.exists()) {
                let collectionMap = collectionDoc.data()[id];
                if (collectionMap != null) {
                    let itemsList = collectionMap["items"] || [];
                    if (itemsList.includes(getItemId)) {
                        itemsList = itemsList.filter(id => id !== getItemId);
                    } else {
                        itemsList.push(getItemId);
                    }

                    await updateDoc(collectionRef, { [`${id}.items`]: itemsList }, { merge: true });
                } 
            }
        } catch (error) {
            console.log(error.message);
        };
    };

    const getAllCollections = useCallback(async () => {
        try {
            const userRef = doc(firebaseFirestore, 'User Collections', getUserId);
            const scription = onSnapshot(userRef, async (docSnapshot) => {
                if (docSnapshot.exists()) {
                    const collectionsData = docSnapshot.data();
                    let collectionsArray = [];
                    Object.keys(collectionsData).forEach((fieldName) => {
                        if (fieldName.startsWith("collection")) {
                            const collection = collectionsData[fieldName];
                            collection.id = fieldName;
                            collectionsArray.push({ ...collection });
                        }
                    });

                    const updatedCollections = await Promise.all(
                        collectionsArray.map(async (collection) => {
                            if (collection.items && collection.items.length > 0) {
                                const itemId = collection.items[0].split("_")[1];
                                const type = collection.items[0].split("_")[0];
                                const details = await getItem({ itemId, type: type === "movie" ? type : "tv" });
                                return { ...collection, image: details.poster_path };
                            }
                            return { ...collection, image: "" };
                        })
                    );

                    const sortedCollections = updatedCollections.sort((a, b) => {
                        if (a.name && b.name) {
                            return a.name.localeCompare(b.name);
                        }
                        return 0;
                    });

                    setCollections(sortedCollections);
                }
            }); 

            return () => scription;
        } catch (error) {
            console.log(error.message); 
        }
    }, [getUserId]);

    useEffect(() => {
        onAuthStateChanged(firebaseAuth, (user) => {
            if (user) {
                setUserId(user.uid);
            }
        });
    }, []);

    useEffect(() => {
        getAllCollections();
    }, [getUserId, getAllCollections]);

    return(
        <div className={`add_item_to_collection_dialog ${getShow ? "show" : ""}`}>
            <div className="add_item_to_collections_header_row">
                <p className="add_item_to_collections_header_row_head">Collections</p>
                <p className="add_item_to_collections_header_row_sub" onClick={() => onAdd()}>Create</p>
            </div>

            <div className="add_item_to_collections_rows_block">
                {
                    getCollections.length > 0
                    ? getCollections.map((collection, index) => (
                        <div key={index} className="add_item_to_collections_rows">
                            <div className="add_item_to_collections_rows_b">
                                <img alt='poster' className="add_item_to_collections_rows_poster" src={collection.image === "" || collection.image == null ? emptyCollectionImage : `https://image.tmdb.org/t/p/w500${collection.image}`} />
                                <div className="add_item_to_collections_column">
                                    <p className="add_item_to_collections_column_name">{collection.name}</p>
                                    <p className="add_item_to_collections_column_privacy">{collection.privacy}</p>
                                </div>
                            </div>
                            <img alt='add' onClick={() => onAddToCollection(collection.id)} className="add_item_to_collections_rows_save" src={collection.items.includes(getItemId) ? activeSaveImage : inactiveSaveImage} />
                        </div>
                    ))
                    : <p style={{textAlign: "center"}}>You don't have any collections.</p>
                }
            </div>
 
            <div className="add_item_to_collections_done" onClick={() => onDone()}>Done</div>
            {getAShow && <AddCollection getShow={getAShow} setShow={setAShow} />}
        </div>
    );
};

export default AddItemToCollection;